import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {
  ActionButton,
  Col,
  Divider,
  GridList,
  Heading,
  Modal,
  ModalBody,
  Paragraph,
  Text,
  Row,
  Spacer,
  Button,
  XIcon,
  UserIcon,
  GroupIcon,
  ArrowRightIcon
} from '@te-digi/styleguide';

const TransitionModal = () => {
  const {formatMessage} = useIntl();
  const [isOpen, setIsOpen] = useState(true);

  const onModalClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      ariaLabelledby="modal-heading"
      centered
      isOpen={isOpen}
      onRequestClose={onModalClose}
      size="xl"
    >
      <ModalBody>
        <Row>
          <Col>
            <Heading id="modal-heading" level={2} icon={<UserIcon />}>
              <Text color="primary">{formatMessage({id: 'tmt_heading'})}</Text>
            </Heading>
          </Col>
          <Col xs="auto">
            <Button onClick={onModalClose} icon={<XIcon />} variant="plain">
              {formatMessage({id: 'general_close'})}
            </Button>
          </Col>
        </Row>
        <Paragraph>{formatMessage({id: 'tmt_body'})}</Paragraph>
        <Spacer marginTop="lg">
          <GridList gap="lg" lg={2} noMargin>
            <ActionButton onClick={onModalClose}>
              {formatMessage({id: 'tmt_continue_button'})}
            </ActionButton>
            <ActionButton
              as="a"
              href={formatMessage({id: 'tmt_regionalpages_link_url'})}
            >
              {formatMessage({id: 'tmt_regionalpages_link_label'})}
            </ActionButton>
          </GridList>
        </Spacer>
        <Divider />
        <Heading level={2} icon={<GroupIcon color="primary" />}>
          <Text color="primary">{formatMessage({id: 'te_heading'})}</Text>
        </Heading>
        <Paragraph>{formatMessage({id: 'te_body'})}</Paragraph>
        <Spacer marginTop="lg">
          <GridList gap="lg" lg={2} noMargin>
            <ActionButton
              as="a"
              href={formatMessage({id: 'tmt_employer_link_url'})}
              iconRight={<ArrowRightIcon color="dark" />}
            >
              {formatMessage({id: 'tmt_employer_link_label'})}
            </ActionButton>
          </GridList>
        </Spacer>
      </ModalBody>
    </Modal>
  );
};

export {TransitionModal};
